import { Administrator } from "src/common/types/administrator";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";

export function systemAdminsReducer(state: Administrator[] = [], action: AnyAction): Administrator[] {
  switch (action.type) {
    case internalActionKeys.GET_SYSTEM_ADMINISTRATORS_SUCCESS:
      return [...action.admins].sort(adminsCompareFunc);
    default:
      return state;
  }
}

export function adminsCompareFunc(a: Administrator, b: Administrator) {
  if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) {
    return 1;
  } else if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
    return -1;
  } else {
    return 0;
  }
}
